module.exports = __webpack_public_path__ + "img/860239.82d81dd.svg";